import auth from "./Auth";
import awardedContract from "./AwardedContract";
import notifications from "./Notifications";
import responses from "./Responses";
import supplierLibraries from "./SupplierLibraries";
import syncState from "./syncState";
import tenders from "./Tenders";
export default [
    notifications,
    auth,
    tenders,
    responses,
    awardedContract,
    supplierLibraries,
    syncState,
];
